import CircularLoading from '@/common/components/base/Loading/CircularLoading';
import CustomLabel from '@/common/components/base/customLabel/CustomLabel';
import Typography from '@/common/components/base/typography/Typography';
import CardButton from '@/common/components/cardButton/CardButton';
import MainLayout from '@/common/components/layouts/MainLayout';
import CulpritAndroidIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/CulpritAndroidIcon.svg?react';
import AdjusterIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/adjuster-icon.svg?react';
import BankAccountIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/bank-account.svg?react';
import OwnerIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/owner.svg?react';
import PropertyInsuranceIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/property-damaged.svg?react';
import RefusalReceiveDamagesIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/refusalReceiveDamagesIcon.svg?react';
import VehicleInformationIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/veichel-info.svg?react';
import { ParticipantsTabType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getParticipantsTabs/getParticipantsTabs.type';
import { getParticipantsTabsQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getParticipantsTabs/getParticipantsTabsQueryOptions';
import { participantsIncidentQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/participantsIncidentList/participantsIncidentQueryOptions';
import { ADJUSTER_REPORT_CULPRIT_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/culprit/culpritLinks';
import getAlertsQueryOptions from '@/modules/adjusterReportModules/adjusterReport/queries/getAlerts/getAlertsQueryOptions';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';

const CulpritInformationTabsPage = () => {
  return (
    <MainLayout title="مقصر" header="titleHeader">
      <CulpritInformationTabs />
    </MainLayout>
  );
};

const CulpritInformationTabs = () => {
  const navigate = useNavigate();
  const { id, culpritId } = useParams();
  const { data } = useQuery(
    getParticipantsTabsQueryOptions({
      user_type: 'culprit',
      damaged_pk: +culpritId!,
      source: 'pwa',
      id: +id!,
    }),
  );
  const { data: participantData } = useQuery(
    participantsIncidentQueryOptions({ id: id!, user: 'culprit' }),
  );

  const { data: alert, isPending } = useQuery(
    getAlertsQueryOptions({
      user_type: 'culprit',
      damaged_pk: culpritId!,
      source: 'pwa',
      id: id!,
    }),
  );

  const refusalReceiveDamages = alert?.alert_detail?.find(
    (item) => item.type === 'refusal_receive_damages',
  );

  const renderRoute = (item: ParticipantsTabType) => {
    const editable = item.editable;
    let tabIcon: Record<ParticipantsTabType['name'], string> = {
      adjusting: '',
      bank: '',
      owner: editable
        ? ADJUSTER_REPORT_CULPRIT_LINKS.CULPRIT_INFORMATION({
            id: +id!,
          }).DRIVER_OWNER_INFORMATION.driver
        : ADJUSTER_REPORT_CULPRIT_LINKS.CULPRIT_INFORMATION({
            id: +id!,
          }).DRIVER_OWNER_INFORMATION.show,
      property_insurance: editable
        ? ADJUSTER_REPORT_CULPRIT_LINKS.CULPRIT_INFORMATION({
            id: +id!,
          }).INSURANCE.edit
        : ADJUSTER_REPORT_CULPRIT_LINKS.CULPRIT_INFORMATION({
            id: +id!,
          }).INSURANCE.show,
      vehicle_information: editable
        ? ADJUSTER_REPORT_CULPRIT_LINKS.CULPRIT_INFORMATION({
            id: +id!,
          }).VEHICLE_INFORMATION.partOne
        : ADJUSTER_REPORT_CULPRIT_LINKS.CULPRIT_INFORMATION({
            id: +id!,
          }).VEHICLE_INFORMATION.show,
    };
    return tabIcon[item.name];
  };

  const goToFile = (item: ParticipantsTabType) => {
    navigate(renderRoute(item));
  };
  console.log(participantData);

  return (
    <Box pt="2rem">
      {refusalReceiveDamages && (
        <Flex
          background={'purpleLinear'}
          borderRadius={8}
          py={4}
          alignItems="center"
          gap={16}
        >
          <Box>
            <RefusalReceiveDamagesIcon />
          </Box>
          <Box>
            <Typography textStyle={'b1'} color="purple-1" textAlign="center">
              زیان‌دیده از دریافت مبلغ خسارت انصراف داده است.
            </Typography>
          </Box>
        </Flex>
      )}
      {isPending ? (
        <Box display="flex" alignItems="center" justifyContent="center">
          <CircularLoading color="colors.purple-primary" />
        </Box>
      ) : (
        <Box
          className={css({
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            position: 'relative',
            top: '-5px',
          })}
        >
          <Box
            className={css({
              display: 'flex',
              alignItems: 'center',
            })}
          >
            <Box
              className={css({
                border: '2px solid #F0EEFF',
                borderRadius: '34px ',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '1rem',
                paddingX: '17px',
              })}
            >
              <CulpritAndroidIcon />
              <Box
                className={css({
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '0.25rem',
                })}
              >
                <Typography textStyle={'b1'} color="purple-1">
                  {participantData?.culprit?.first_name}{' '}
                  {participantData?.culprit?.last_name}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box
            className={css({
              backgroundColor: '#EBEBEB',
              width: '100%',
              height: '1px',
            })}
          ></Box>
          <Box>
            {data?.map((item) =>
              item?.is_card_active ? (
                <CardButton
                  key={item?.name}
                  cardProps={{
                    className: css({ marginY: '1rem' }),
                    onClick: () => goToFile(item),
                  }}
                  hasArrow
                  renderTag={() =>
                    item?.label && (
                      <CustomLabel
                        title={item?.label?.fa_const}
                        color={
                          item?.label?.const === 'completed'
                            ? 'green'
                            : 'yellow'
                        }
                      />
                    )
                  }
                  renderIcon={() => renderIcon(item?.name)}
                  title={item?.fa_name}
                />
              ) : null,
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
};
const renderIcon = (tabName: ParticipantsTabType['name']) => {
  let tabIcon: Record<ParticipantsTabType['name'], React.JSX.Element> = {
    adjusting: <AdjusterIcon />,
    bank: <BankAccountIcon />,
    owner: <OwnerIcon />,
    property_insurance: <PropertyInsuranceIcon />,
    vehicle_information: <VehicleInformationIcon />,
  };
  return tabIcon[tabName];
};
export default CulpritInformationTabsPage;
